import script from "./device-distribution.vue?vue&type=script&lang=ts&setup=true"
export * from "./device-distribution.vue?vue&type=script&lang=ts&setup=true"

import "./device-distribution.vue?vue&type=style&index=0&id=05c6875e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c6875e"]])

export default __exports__